import validateForm from './validateForm';
import requiredValidator from '../validations/requiredValidator';

const VALIDATIONS = {
  requiredFields: {
    fields: ['password', 'passwordConfirmation'],
    handler: requiredValidator,
  },
};

export default form => validateForm(form, VALIDATIONS);



// WEBPACK FOOTER //
// ./src/utils/auth/editUserValidation.js